import { getLogger } from '@signalwire/core';
import { getUserMedia as _getUserMedia } from './getUserMedia';
import { assureDeviceId } from './deviceHelpers';
// FIXME: Remove and use getUserMedia directly
export const getUserMedia = (constraints) => {
    getLogger().info('RTCService.getUserMedia', constraints);
    const { audio, video } = constraints;
    if (!audio && !video) {
        return;
    }
    return _getUserMedia(constraints);
};
export const getMediaConstraints = async (options) => {
    var _a, _b;
    const { micLabel = '', micId } = options;
    let audio = (_a = options.audio) !== null && _a !== void 0 ? _a : true;
    if (micId && audio) {
        const newMicId = await assureDeviceId(micId, micLabel, 'microphone').catch((_error) => null);
        if (newMicId) {
            if (typeof audio === 'boolean') {
                audio = {};
            }
            audio.deviceId = { exact: newMicId };
        }
    }
    const { camLabel = '', camId } = options;
    let video = (_b = options.video) !== null && _b !== void 0 ? _b : true;
    if (camId && video) {
        const newCamId = await assureDeviceId(camId, camLabel, 'camera').catch((_error) => null);
        if (newCamId) {
            if (typeof video === 'boolean') {
                video = {};
            }
            video.deviceId = { exact: newCamId };
        }
    }
    return { audio, video };
};
export const filterIceServers = (servers, options) => {
    const { disableUdpIceServers = false } = options;
    const filterOutUdpUrls = (urls) => {
        const transportParam = 'transport=udp';
        if (Array.isArray(urls)) {
            return urls.filter((url) => !url.includes(transportParam));
        }
        return urls.includes(transportParam) ? '' : urls;
    };
    return servers.map((server) => (Object.assign(Object.assign({}, server), { urls: disableUdpIceServers ? filterOutUdpUrls(server.urls) : server.urls })));
};
/**
 * Check if the negotiation is single media (audio or video only).
 * This is used to determine if we should handle SDP negotiation differently.
 */
export const isSingleMediaNegotiation = (options) => {
    const { audio, video, negotiateAudio, negotiateVideo } = options;
    const hasAudio = Boolean(audio || negotiateAudio);
    const hasVideo = Boolean(video || negotiateVideo);
    return (hasAudio && !hasVideo) || (!hasAudio && hasVideo);
};
//# sourceMappingURL=helpers.js.map